import { render, staticRenderFns } from "./PaperPriceTab.vue?vue&type=template&id=7e32dd0a&"
import script from "./PaperPriceTab.ts?vue&type=script&lang=js&"
export * from "./PaperPriceTab.ts?vue&type=script&lang=js&"
import style0 from "./PaperPriceTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports